<template>
    <div class="floating-customer-service">
        <div class="lottery">
<!--            <img @click="$router.push('/chip')" src="@/assets/images/logo/Boston.svg" style=" border-radius: 50%;object-fit: contain;cursor: pointer;">-->
        </div>
        <!-- 悬浮按钮 -->
        <div class="toggle-button" @click="togglePanel" @touchstart.prevent="togglePanel">
            <div class="icon-wrapper">
                <img :src="require('@/assets/svg/headset.svg')" class="svg-icon">
            </div>
        </div>

        <!-- 联系客服面板 -->
        <div class="contact-panel" v-if="isPanelVisible">
            <div class="panel-header">
                <h3>{{$t('Contact Us')}}</h3>
                <button class="close-btn" @click="hidePanel">
                    <img :src="require('@/assets/svg/times.svg')" class="svg-icon">
                </button>
            </div>`
            <div class="contact-options">
                <a v-if="telegramGroup" :href="'https://t.me/' + telegramGroup.replace('@', '')"  target="_blank" class="contact-option telegram">
                    <div class="icon">
                        <img :src="require('@/assets/svg/telegram.svg')" alt="Telegram" class="svg-icon">
                    </div>
                    <div class="info">
                        <h4>Telegram</h4>
                        <p>{{telegramGroup}}</p>
                    </div>
                </a>
<!--                <a :href="'https://t.me/' + telegramChannel.replace('@', '')" target="_blank" class="contact-option telegram">-->
<!--                    <div class="icon">-->
<!--                        <img :src="require('@/assets/svg/telegram.svg')" alt="Telegram" class="svg-icon">-->
<!--                    </div>-->
<!--                    <div class="info">-->
<!--                        <h4>Telegram频道</h4>-->
<!--                        <p>{{telegramChannel}}</p>-->
<!--                    </div>-->
<!--                </a>-->
<!--                <a :href="kefuLink" class="contact-option telegram">-->
<!--                    <div class="icon">-->
<!--                        <img :src="require('@/assets/svg/customer.svg')" class="svg-icon">-->
<!--                    </div>-->
<!--                    <div class="info">-->
<!--                        <h4>{{$t('Live Chat')}}</h4>-->
<!--&lt;!&ndash;                        <p>{{kefuLink}}</p>&ndash;&gt;-->
<!--                    </div>-->
<!--                </a>-->
                <a v-if="whatsappNumber" :href="'https://wa.me/' + whatsappNumber.replace(/\D/g, '')" target="_blank" class="contact-option whatsapp">
                    <div class="icon">
                        <img :src="require('@/assets/svg/whatsapp.svg')" alt="WhatsApp" class="svg-icon">
                    </div>
                    <div class="info">
                        <h4>WhatsApp</h4>
                        <p>{{whatsappNumber}}</p>
                    </div>
                </a>
            </div>
            <div class="panel-footer">
<!--                <p>{{$t('Business Hours')}}: 10:00-21:00 (UTC+8)</p>-->
            </div>
        </div>
    </div>
</template>

<script>
    import Fetch from '../utils/fetch';

    export default {
        name: "FloatingService",
        data() {
            return {
                isPanelVisible: false,
                app: {},
                telegramGroup:'',
                telegramChannel:'',
                whatsappNumber:'',
                kefuLink:'',
            };
        },
        computed: {
            // telegramGroup() {
            //     return this.$store.state.config.tg
            // },
            // telegramChannel() {
            //     return ''
            // },
            // whatsappNumber() {
            //     return this.$store.state.config.whatsapp
            // },
            // kefuLink() {
            //     return this.$store.state.config.kefu_link
            // },
        },
        mounted() {

        },
        beforeDestroy() {

        },
        methods: {
            getConfig() {
                Fetch("/index/getKf").then((r) => {
                    this.app = r.data;
                    this.telegramGroup = r.data.tg;
                    this.whatsappNumber = r.data.whatsapp;
                    this.kefuLink = r.data.kefu_link;

                    this.isPanelVisible = !this.isPanelVisible;
                });
            },
            togglePanel() {
                // console.log(this.$store.state.config.kefu_link)
                if(!this.isPanelVisible) {
                    this.getConfig();
                } else {
                    this.isPanelVisible = !this.isPanelVisible;
                }
            },
            hidePanel() {
                this.isPanelVisible = false;
            },
        }
    };
</script>

<style scoped>
    /* 全局样式 */
    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
    }

    body {
        background-color: #f5f5f5;
    }

    /* SVG 图标样式 */
    .svg-icon {
        width: 20px;
        height: 20px;
        stroke: currentColor;
        stroke-width: 2;
    }

    /* 悬浮客服主容器 */
    .floating-customer-service {
        position: fixed;
        bottom: 60px;
        right: 20px;
        z-index: 9999;
        /*display: flex;*/
        flex-direction: row;
        align-items: center;
    }

    /* 触发按钮样式 - 圆形布局 */
    .toggle-button {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: linear-gradient(90deg,#49bcfc,#3b92f8)!important;
        color: white;
        padding: 10px;
        border-radius: 50%;
        cursor: pointer;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        transition: all 0.3s ease;
        width: 45px;
        height: 45px;
        position: relative;
        z-index: 10000;
    }

    .toggle-button:hover {
        transform: translateY(-5px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    }

    .icon-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0;
    }

    .toggle-button .svg-icon {
        width: 35px;
        height: 35px;
        stroke: white;
    }

    /* 联系面板 */
    .contact-panel {
        position: fixed;
        width: 340px;
        background-color: white;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        overflow: hidden;
        z-index: 9998;
        transition: opacity 0.3s ease, transform 0.3s ease;
        transform: scale(0.95);
        opacity: 1;
        bottom: 100px;
        right: 45px;
    }

    .contact-panel.active {
        transform: scale(1);
        opacity: 1;
    }

    /* 面板头部 */
    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(90deg,#49bcfc,#3b92f8)!important;
        color: white;
        padding: 15px 15px;
    }

    .panel-header h3 {
        font-size: 18px;
        font-weight: 500;
    }

    .close-btn {
        background: transparent;
        border: none;
        color: white;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
    }

    .close-btn .svg-icon {
        stroke: white;
    }

    .close-btn:hover {
        transform: scale(1.2);
    }

    /* 联系选项 */
    .contact-options {
        padding: 15px;
        padding-top: unset;
    }

    .contact-option {
        display: flex;
        align-items: center;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 10px;
        text-decoration: none;
        color: #333;
        transition: all 0.3s ease;
    }

    .contact-option:last-child {
        margin-bottom: 0;
    }

    .contact-option .icon {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;
    }

    .contact-option .icon .svg-icon {
        width: 30px;
        height: 30px;
        stroke: white;
    }

    .contact-option .info h4 {
        font-weight: 500;
        margin-bottom: 5px;
        font-size:16px;
    }

    .contact-option .info p {
        font-size: 14px;
        color: #666;
    }

    /* 各平台特定样式 */
    .telegram {
        background-color: rgba(0, 136, 204, 0.1);
    }

    .telegram:hover {
        background-color: rgba(0, 136, 204, 0.2);
    }

    .telegram .icon {
        background-color: #0088cc;
    }

    .whatsapp {
        background-color: rgba(37, 211, 102, 0.1);
    }

    .whatsapp:hover {
        background-color: rgba(37, 211, 102, 0.2);
    }

    .whatsapp .icon {
        background-color: #25D366;
    }

    .qq {
        background-color: rgba(0, 120, 215, 0.1);
    }

    .qq:hover {
        background-color: rgba(0, 120, 215, 0.2);
    }

    .qq .icon {
        background-color: #0078d7;
    }

    /* 面板底部 */
    .panel-footer {
        padding: 10px 20px;
        text-align: center;
        background-color: #f8f9fa;
        font-size: 13px;
        color: #777;
    }

    /* 响应式设计 */
    @media (max-width: 480px) {
        .contact-panel {
            width: 280px;
            bottom: 95px;
            right: 28px;
        }

        .floating-customer-service {
            bottom: 60px;
            right: 10px;
        }
    }
    .lottery {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
    }
    .lottery img {
        width: 50px;
        height: 50px;
        animation: pulse 2s infinite ease-in-out;
    }
    /* 定义动画 */
    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
